import _ from 'lodash';
import { CALLBACK_SUPPORTED_ON_BROKER_DOMAINS } from 'common/constants/index';
import { initiateBrokerCallbackLogin } from 'common/auth/modalLogin';
import { reactToastify, TOASTIFY_TYPES } from 'v3/common/utils/reactToastify';
import { ACTIVE_BROKERS_DOMAINS } from '../../types.type';
import { BrokerConfig } from './types.type';

const getBrokerConfigs = () => {
  // These congif is taken from the application domain config which is set in the backend based on the domain and subdomain
  const domainBrokerIds = _.get(window, 'applicationDomain.config.brokerConfigs');
  // const allBrokerConfigs = window.brokerConfigs || {};

  // If domain has specific broker IDs configured, filter the global configs
  // if (_.isArray(domainBrokerIds) && domainBrokerIds.length > 0) {
  //   return domainBrokerIds.map((id: string) => allBrokerConfigs[id]).filter(Boolean);
  // }
  // Otherwise return all broker configs as array
  return _.values(domainBrokerIds);
};

export const onReDirectPage = (
  reDirectData: object,
  broker: string,
  isRedirectToCallbackPath: boolean,
  callBackFn: () => void
) => {
  let reDirectUrl = `/auth/${broker}`;

  if (isRedirectToCallbackPath) reDirectUrl += '/callback?';
  else reDirectUrl += '?';

  let index = 0;
  _.each(reDirectData, (data, key) => {
    reDirectUrl += !index ? `${key}=${encodeURIComponent(data)}` : `&${key}=${encodeURIComponent(data)}`;
    index += 1;
  });

  if (CALLBACK_SUPPORTED_ON_BROKER_DOMAINS.includes(broker)) {
    initiateBrokerCallbackLogin(reDirectUrl)
      .then((res) => {
        window.location.href = res?.href;
      })
      .catch(() => {
        reactToastify('Unauthorized, Please Login again!!!', TOASTIFY_TYPES.ERROR);
        callBackFn();
      });
  } else {
    window.location.href = reDirectUrl;
  }
};

export const cleanObject = (obj: Record<string, string | number | null | undefined | object>) =>
  _.pickBy(obj, (value) => value !== '' && value !== null && value !== undefined);

export const findBrokerConfigById = (brokerId: ACTIVE_BROKERS_DOMAINS): BrokerConfig | undefined => {
  const brokerConfigs = getBrokerConfigs();
  return _.find(brokerConfigs, { id: brokerId });
};

// export const isSingleBrokerDomain = (): boolean => {
//   const brokerConfigs = getBrokerConfigs();
//   return brokerConfigs.length === 1;
// };
